/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ProposalsProposalIdRequest = {
  proposalId: number;
};

/** @internal */
export const GetApiV3ProposalsProposalIdRequest$inboundSchema: z.ZodType<
  GetApiV3ProposalsProposalIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  proposal_id: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "proposal_id": "proposalId",
  });
});

/** @internal */
export type GetApiV3ProposalsProposalIdRequest$Outbound = {
  proposal_id: number;
};

/** @internal */
export const GetApiV3ProposalsProposalIdRequest$outboundSchema: z.ZodType<
  GetApiV3ProposalsProposalIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ProposalsProposalIdRequest
> = z.object({
  proposalId: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    proposalId: "proposal_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsProposalIdRequest$ {
  /** @deprecated use `GetApiV3ProposalsProposalIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ProposalsProposalIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ProposalsProposalIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3ProposalsProposalIdRequest$Outbound;
}

export function getApiV3ProposalsProposalIdRequestToJSON(
  getApiV3ProposalsProposalIdRequest: GetApiV3ProposalsProposalIdRequest,
): string {
  return JSON.stringify(
    GetApiV3ProposalsProposalIdRequest$outboundSchema.parse(
      getApiV3ProposalsProposalIdRequest,
    ),
  );
}

export function getApiV3ProposalsProposalIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3ProposalsProposalIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ProposalsProposalIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ProposalsProposalIdRequest' from JSON`,
  );
}
